import{
  FETCH_PAGE_USER_INFO_LOADING,
  FETCH_PAGE_USER_INFO_SUCCESS,
  FETCH_PAGE_USER_INFO_FAIL,
  FETCH_PAGE_USER_SUMMARY_LOADING,
  FETCH_PAGE_USER_SUMMARY_SUCCESS,
  FETCH_PAGE_USER_SUMMARY_FAIL,
  FETCH_PAGE_USERS_PAGINATED_LOADING,
  FETCH_PAGE_USERS_PAGINATED_SUCCESS,
  FETCH_PAGE_USERS_PAGINATED_FAIL,
  FETCH_PAGE_USER_PHONENAME_LOADING,
  FETCH_PAGE_USER_PHONENAME_SUCCESS,
  FETCH_PAGE_USER_PHONENAME_FAIL,
  FETCH_PAGE_USER_DRINKS_LOADING,
  FETCH_PAGE_USER_DRINKS_SUCCESS,
  FETCH_PAGE_USER_DRINKS_FAIL,
  FETCH_PAGE_USER_CRAFTEDDRINKS_LOADING,
  FETCH_PAGE_USER_CRAFTEDDRINKS_SUCCESS,
  FETCH_PAGE_USER_CRAFTEDDRINKS_FAIL,
  FETCH_PAGE_USER_MYBAR_LOADING,
  FETCH_PAGE_USER_MYBAR_SUCCESS,
  FETCH_PAGE_USER_MYBAR_FAIL,
  FETCH_RECENTLY_MADE_DRINKS_LOADING,
  FETCH_RECENTLY_MADE_DRINKS_SUCCESS,
  FETCH_RECENTLY_MADE_DRINKS_FAIL,
  FETCH_RECENTLY_MOST_REPEATED_DRINKS_LOADING,
  FETCH_MOST_REPEATED_DRINKS_SUCCESS,
  FETCH_MOST_REPEATED_DRINKS_FAIL,
  FETCH_FAVOURITE_DRINKS_LOADING,
  FETCH_FAVOURITE_DRINKS_SUCCESS,
  FETCH_FAVOURITE_DRINKS_FAIL,
  SET_USERS_PAGE_CURRENT,
  SET_USERS_ITEMS_PER_PAGE,
  SET_USERS_SEARCH_TERM,
  SET_USERS_USER_TYPE,
  SET_USERS_DATE_OPTION,
  SET_USERS_AGE_OPTION,
  SET_USERS_CUSTOM_DATE_RANGE,
  SET_USERS_START_DATE,
  SET_USERS_END_DATE,
  FETCH_USER_DEVICES_LOADING,
  FETCH_USER_DEVICES_SUCCESS,
  FETCH_USER_DEVICES_FAIL,
} from "../actions/types";

const INITIAL_STATE = {
    //Devices state for user
    user_devices: [], // Array to store the user's devices
    user_devices_error: null, // Error message for devices fetch
    loading_user_devices: false, // Loading state for fetching devices
    // PROFILE PAGE - Most Made Drinks
    profile_user_favdrinks: [],
    profile_user_favdrinks_error: null,
    loading_profile_user_favdrinks: false,
    // PROFILE PAGE - Most Made Drinks
    profile_user_mostdrinks: [],
    profile_user_mostdrinks_error: null,
    loading_profile_user_mostdrinks: false,
    // PROFILE PAGE - Recently Made Drinks
    profile_user_recentdrinks: [],
    profile_user_recentdrinks_total: 0,
    profile_user_recentdrinks_error: null,
    loading_profile_user_recentdrinks: false,
    // PROFILE PAGE - My Bar
    profile_user_mybar: [],
    profile_user_mybar_total: 0,
    profile_user_mybar_error: null,
    loading_profile_user_mybar: false,
    // PROFILE PAGE - User's my drinks
    profile_user_crafteddrinks: [],
    profile_user_crafteddrinks_total: 0,
    profile_user_crafteddrinks_error: null,
    loading_profile_user_crafteddrinks: false,
    // PROFILE PAGE - User's my drinks
    profile_user_drinks: [],
    profile_user_drinks_total: 0,
    profile_user_drinks_error: null,
    loading_profile_user_drinks: false,
    //PROFILE PAGE - username/phone
    profile_user_info: {},
    profile_user_error: null,
    loading_profile_user: false,
    //PAGE USER INFO
    page_user_info: [],
    page_user_error: null,
    loading_page_user: false,
    //PAGE USER SUMMARY INFO
    page_user_summary_info: [],
    page_user_summary_error: null,
    loading_user_summary: false,
    // USERS PAGINATED INFO
    users_paginated_info: [],
    users_paginated_error: null,
    loading_users_paginated: false,
    // --- Store all the user table UI state below ---
    users_page_current: 1,
    users_items_per_page: 20,
    users_search_term: "",
    users_user_type: 0, // 0 = Registered, 1 = Active
    users_date_option: 2, // Corresponds to your default in dateOptions
    users_age_option: "0",
    users_custom_date_range: false,
    users_start_date: null,
    users_end_date: null,
};

const usersReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        //User Profile DEVICES
        case FETCH_USER_DEVICES_LOADING:
            return { ...state, loading_user_devices: true };

        case FETCH_USER_DEVICES_FAIL:
            return {
                ...state,
                user_devices: [],
                user_devices_error: action.payload,
                loading_user_devices: false,
            };

        case FETCH_USER_DEVICES_SUCCESS:
            // console.log('Reducer USER DEVICES: ', action.payload.devices)
            return {
                ...state,
                user_devices: action.payload || [],
                user_devices_error: null,
                loading_user_devices: false,
            };
        //Users Filter State
       case SET_USERS_PAGE_CURRENT:
         return { ...state, users_page_current: action.payload };
        case SET_USERS_ITEMS_PER_PAGE:
            return { ...state, users_items_per_page: action.payload };
        case SET_USERS_SEARCH_TERM:
            return { ...state, users_search_term: action.payload };
        case SET_USERS_USER_TYPE:
            return { ...state, users_user_type: action.payload };
        case SET_USERS_DATE_OPTION:
            return { ...state, users_date_option: action.payload };
        case SET_USERS_AGE_OPTION:
            return { ...state, users_age_option: action.payload };
        case SET_USERS_CUSTOM_DATE_RANGE:
            return { ...state, users_custom_date_range: action.payload };
        case SET_USERS_START_DATE:
            return { ...state, users_start_date: action.payload };
        case SET_USERS_END_DATE:   
            return { ...state, users_end_date: action.payload };
            // Favourite Drinks Section Data
        case FETCH_FAVOURITE_DRINKS_LOADING:
                return { ...state, loading_profile_user_favdrinks: true };
        case FETCH_FAVOURITE_DRINKS_FAIL:
            return {
                ...state,
                profile_user_favdrinks: [],
                profile_user_favdrinks_error: action.payload,
                loading_profile_user_favdrinks: false
            };
        case FETCH_FAVOURITE_DRINKS_SUCCESS:
            return {
                ...state,
                profile_user_favdrinks: action.payload.drinks || [],
                profile_user_favdrinks_error: null,
                loading_profile_user_favdrinks: false
            };


        // Most Made Drinks Section Data
        case FETCH_RECENTLY_MOST_REPEATED_DRINKS_LOADING:
            return { ...state, loading_profile_user_mostdrinks: true };
        case FETCH_MOST_REPEATED_DRINKS_FAIL:
            return {
                ...state,
                profile_user_mostdrinks: [],
                profile_user_mostdrinks_error: action.payload,
                loading_profile_user_mostdrinks: false
            };
        case FETCH_MOST_REPEATED_DRINKS_SUCCESS:
            return {
                ...state,
                profile_user_mostdrinks: action.payload.drinks || [],
                profile_user_mostdrinks_error: null,
                loading_profile_user_mostdrinks: false
            };
         // Recently Made Drinks Section Data
        case FETCH_RECENTLY_MADE_DRINKS_LOADING:
            return { ...state, loading_profile_user_recentdrinks: true };
        case FETCH_RECENTLY_MADE_DRINKS_FAIL:
            return {
                ...state,
                profile_user_recentdrinks: [],
                profile_user_recentdrinks_total: 0,
                profile_user_recentdrinks_error: action.payload,
                loading_profile_user_recentdrinks: false
            };
        case FETCH_RECENTLY_MADE_DRINKS_SUCCESS:
            return {
                ...state,
                profile_user_recentdrinks: action.payload.drinks || [],
                profile_user_recentdrinks_total: action.payload.total_drinks || 0,
                profile_user_recentdrinks_error: null,
                loading_profile_user_recentdrinks: false
            };
           // My Bar
        case FETCH_PAGE_USER_MYBAR_LOADING:
            return { ...state, loading_profile_user_mybar: true };
        case FETCH_PAGE_USER_MYBAR_FAIL:
            return {
                ...state,
                profile_user_mybar: [],
                profile_user_mybar_total: 0,
                profile_user_mybar_error: action.payload,
                loading_profile_user_mybar: false
            };
        case FETCH_PAGE_USER_MYBAR_SUCCESS:
            return {
                ...state,
                profile_user_mybar: action.payload.my_bar.ingredients || [],
                profile_user_mybar_total: action.payload.my_bar.total_ingredients || 0,
                profile_user_mybar_error: null,
                loading_profile_user_mybar: false
            };
                // My Crafted Drinks
        case FETCH_PAGE_USER_CRAFTEDDRINKS_LOADING:
            return { ...state, loading_profile_user_crafteddrinks: true };
        case FETCH_PAGE_USER_CRAFTEDDRINKS_FAIL:
            return { 
                ...state, 
                profile_user_crafteddrinks: [], 
                profile_user_crafteddrinks_total: 0,
                profile_user_crafteddrinks_error: action.payload, 
                loading_profile_user_crafteddrinks: false 
            };
        case FETCH_PAGE_USER_CRAFTEDDRINKS_SUCCESS:
            return { 
                ...state, 
                profile_user_crafteddrinks: action.payload.drinks || [],
                profile_user_crafteddrinks_total: action.payload.total_drinks || 0,
                profile_user_crafteddrinks_error: null, 
                loading_profile_user_crafteddrinks: false 
            };
        // My Drinks
        case FETCH_PAGE_USER_DRINKS_LOADING:
            return { ...state, loading_profile_user_drinks: true };
        case FETCH_PAGE_USER_DRINKS_FAIL:
            return { 
                ...state, 
                profile_user_drinks: [], 
                profile_user_drinks_total: 0,
                profile_user_drinks_error: action.payload, 
                loading_profile_user_drinks: false 
            };
        case FETCH_PAGE_USER_DRINKS_SUCCESS:
            return { 
                ...state, 
                profile_user_drinks: action.payload.drinks || [],
                profile_user_drinks_total: action.payload.total_drinks || 0,
                profile_user_drinks_error: null, 
                loading_profile_user_drinks: false 
            };
        //Page Profile User
        case FETCH_PAGE_USER_PHONENAME_FAIL:
            return { 
                ...state, 
                profile_user_info: [], 
                profile_user_error: action.payload, 
                loading_profile_user: false 
            };

        case FETCH_PAGE_USER_PHONENAME_LOADING:
            return { ...state, loading_profile_user: true };
            
        case FETCH_PAGE_USER_PHONENAME_SUCCESS:
            // console.log('Payload in reducer FETCH_PAGE_USER_INFO_SUCCESS:');
            return { 
                ...state, 
                profile_user_info: action.payload,
                profile_user_error: null, 
                loading_profile_user: false 
            };
        //Page User Info - Users Page
        case FETCH_PAGE_USER_INFO_FAIL:
            return { 
                ...state, 
                page_user_info: [], 
                page_user_error: action.payload, 
                loading_page_user: false 
            };

        case FETCH_PAGE_USER_INFO_LOADING:
            return { ...state, loading_page_user: true };
            
        case FETCH_PAGE_USER_INFO_SUCCESS:
            // console.log('Payload in reducer FETCH_PAGE_USER_INFO_SUCCESS:');
            return { 
                ...state, 
                page_user_info: action.payload,
                page_user_error: null, 
                loading_page_user: false 
            };
        //USER PAGE SUMMARY STATE
         case FETCH_PAGE_USER_SUMMARY_FAIL:
            return { ...state, 
                page_user_summary_info: [], 
                page_user_summary_error: action.payload, 
                loading_user_summary: false 
            };

        case FETCH_PAGE_USER_SUMMARY_LOADING:
            return { ...state, loading_user_summary: true };
            
        case FETCH_PAGE_USER_SUMMARY_SUCCESS:
            // console.log('Payload in reducer FETCH_PAGE_USER_INFO_SUCCESS:');
            return { 
                ...state, 
                page_user_summary_info: action.payload,
                page_user_summary_error: null, 
                loading_user_summary: false 
            };
        // USER PAGINATED INFO
        case FETCH_PAGE_USERS_PAGINATED_FAIL:
            return { ...state, 
                users_paginated_info: [], 
                users_paginated_error: action.payload, 
                loading_users_paginated: false 
            };

        case FETCH_PAGE_USERS_PAGINATED_LOADING:
            return { ...state, loading_users_paginated: true };
            
        case FETCH_PAGE_USERS_PAGINATED_SUCCESS:
            console.log('Payload in reducer FETCH_PAGE_USERS_PAGINATED_SUCCESS:', action.payload);
            return { 
                ...state, 
                users_paginated_info: action.payload,
                users_paginated_error: null, 
                loading_users_paginated: false 
            };
        default:
            return state;
    }
};
      
export default usersReducer;